module.exports = __webpack_public_path__ + "static/media/UkPIClub.adc5ef3c.svg";